export default __webpack_public_path__ + "static/media/text-blue.967353f3.svg";